import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone, ArrowRight } from 'lucide-react';
import { CONTACT, NAV_LINKS, GROUP_BRANDS } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-[#0f2340] text-gray-300">
      {/* CTA strip */}
      <div className="bg-[#1ca5dc]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <h3 className="text-white text-xl md:text-2xl font-heading font-bold text-center md:text-left">
            EIG: For insight into the UAE education sector
          </h3>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-white text-[#132b4d] font-heading font-semibold px-7 py-3 rounded-full hover:bg-[#0f2340] hover:text-white transition-colors duration-200"
          >
            Contact Us <ArrowRight size={18} />
          </Link>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <a href="https://which-media.com" target="_blank" rel="noopener noreferrer" className="inline-block">
            <img src="/eig-logo-footer.png" alt="Education Intelligence Group" className="h-14 w-auto" />
          </a>
          <p className="mt-4 text-sm leading-relaxed text-gray-400">
            The Education Intelligence Group — illuminating insights, plans, strategy and data for the
            UAE education sector.
          </p>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold mb-4 uppercase text-sm tracking-wide">
            Navigate
          </h4>
          <ul className="space-y-2 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="hover:text-[#1ca5dc] transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold mb-4 uppercase text-sm tracking-wide">
            Sister brands
          </h4>
          <div className="flex flex-wrap gap-3">
            {GROUP_BRANDS.map((b) => {
              const inner = (
                <div className="bg-white rounded-lg px-3 py-2 flex items-center justify-center h-11 w-[120px]">
                  <img src={b.logo} alt={b.name} className="max-h-7 max-w-full w-auto object-contain" />
                </div>
              );
              return b.url ? (
                <a key={b.name} href={b.url} target="_blank" rel="noopener noreferrer" className="hover:opacity-90 transition-opacity">
                  {inner}
                </a>
              ) : (
                <div key={b.name}>{inner}</div>
              );
            })}
          </div>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold mb-4 uppercase text-sm tracking-wide">
            Get in touch
          </h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin size={18} className="text-[#1ca5dc] mt-0.5 shrink-0" />
              <span>{CONTACT.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={18} className="text-[#1ca5dc] shrink-0" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-[#1ca5dc] break-all transition-colors">
                {CONTACT.email}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={18} className="text-[#1ca5dc] shrink-0" />
              <a href={`tel:${CONTACT.phone.replace(/\s/g, '')}`} className="hover:text-[#1ca5dc] transition-colors">
                {CONTACT.phone}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 text-xs text-gray-500 flex flex-col md:flex-row items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} Education Intelligence Group. All rights reserved.</span>
          <span>
            Part of the{' '}
            <a href="https://which-media.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#1ca5dc] font-medium transition-colors">
              Which Media
            </a>{' '}
            group.
          </span>
        </div>
      </div>
    </footer>
  );
}
